'use client';
import { useRouter } from 'next/navigation';
import Button from '../components/ui/Button';

// Reusable card component with corner decorations
interface AudienceCardProps {
  title: string;
  description: string;
  buttonText: string;
}

function AudienceCard({ title, description, buttonText }: AudienceCardProps) {
  const router = useRouter();

  const handleClick = () => {
    router?.push('/register');
  };

  return (
    <div className="relative w-full h-full">
      {/* Corner decorations */}
      {/* Top-left corner */}
      

      {/* Card content */}
      <div className="flex flex-col justify-between h-full bg-[#2a0f3a]/80 rounded-sm p-6 sm:p-8 lg:p-10 min-h-[220px]">
        <div className="flex flex-col gap-4">
          <h4 className="text-[18px] sm:text-[22px] lg:text-[26px] font-bebas font-normal leading-[1.2] text-left text-white uppercase tracking-wide">
            {title}
          </h4>
          
          <p className="text-[14px] sm:text-[15px] lg:text-[16px] font-poppins font-normal leading-[1.6] text-left text-[#e4e4e4]">
            {description}
          </p>
        </div>
        
        <div className="mt-6">
          <Button
            text={buttonText}
            text_font_size="text-[11px] sm:text-xs"
            text_font_family="Helvetica"
            text_font_weight="font-normal"
            text_line_height="leading-normal"
            text_text_align="center"
            text_text_transform="uppercase"
            text_color="text-white"
            fill_background_color="bg-transparent"
            border_border_radius="rounded-full"
            className="w-full border-2 border-white py-3.5 px-6 hover:bg-white hover:text-[#3f1651] transition-all duration-300 tracking-wider"
            onClick={handleClick}
          />
        </div>
      </div>
    </div>
  );
}

export default function TargetAudienceSection() {
  const audienceData = [
    {
      title: "Agencies",
      description: "Add creative capacity without adding payroll. White label available.",
      buttonText: "SCALE YOUR AGENCY WITH US"
    },
    {
      title: "Subscription and Membership Companies",
      description: "Steady creative support for retention, growth, and engagement.",
      buttonText: "INCREASE YOUR PRODUCTION"
    },
    {
      title: "Service Businesses and Experts",
      description: "Look polished across all platforms without overworking your internal team.",
      buttonText: "UPGRADE YOUR BRAND PRESENCE"
    },
    {
      title: "Business Leaders Who Want Reliability",
      description: "Whether you're a CEO, COO, CMO, director, owner, or manager — this removes your creative bottlenecks permanently.",
      buttonText: "END CREATIVE BOTTLENECKS"
    }
  ];

  return (
    <section 
      className="w-full bg-[#3f1651] py-16 sm:py-20 lg:py-28"
      style={{
        backgroundImage: "url('/who_we_are_bg.png')",
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat'
      }}
    >
      <div className="w-full max-w-[1440px] mx-auto px-4 sm:px-6 lg:px-24 xl:px-36">
        
        {/* Header */}
        <div className="flex flex-col justify-start items-start w-full mb-12 sm:mb-14 lg:mb-16">
          <h2 className="text-[40px] sm:text-[60px] lg:text-[80px] xl:text-[90px] font-bebas font-normal leading-[0.95] text-left text-[#ffefef] uppercase">
            Who Purple Cow
          </h2>
          <h3 className="text-[40px] sm:text-[60px] lg:text-[80px] xl:text-[90px] font-bebas font-normal leading-[0.95] text-left text-[#ffefef] uppercase">
            Unlimited Is Perfect For
          </h3>
        </div>

        {/* Target Audience Grid */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 sm:gap-8 lg:gap-10">
          {audienceData.map((item, index) => (
            <AudienceCard
              key={index}
              title={item.title}
              description={item.description}
              buttonText={item.buttonText}
            />
          ))}
        </div>
      </div>
    </section>
  );
}
